export default "__VITE_ASSET__9d0f4711__"